// extracted by mini-css-extract-plugin
export default {"mainCont":"DialogCamShot_mainCont__+JgOI","dgButton":"DialogCamShot_dgButton__4cHtm"};